import Header from '../layout/Header.jsx';
import Footer from '../layout/Footer.jsx';

// TODO(launch): defaults below limit legal pages to "no header links" + "footer
// with legal cross-links only" while the site is in Coming Soon mode. At launch,
// switch the defaults to headerVariant="landing" and footerVariant="landing" so
// visitors can navigate back to the full site.
// See also TODO(launch) in src/App.jsx.
export default function LegalLayout({
  eyebrow = 'Documento legal',
  title,
  intro,
  meta,
  toc,
  children,
  headerVariant = 'bare',
  footerVariant = 'legal',
}) {
  return (
    <>
      <Header variant={headerVariant} />
      <div className="page-wrap">
        <section className="legal-hero">
          <div className="legal-hero-inner">
            <span className="legal-eyebrow">{eyebrow}</span>
            <h1>{title}</h1>
            {intro && <p>{intro}</p>}
            {meta && (
              <div className="legal-meta">
                {meta.map(({ label, value }) => (
                  <span key={label}>
                    <strong>{label}:</strong> {value}
                  </span>
                ))}
              </div>
            )}
          </div>
        </section>

        <div className="legal-content">
          <aside className="legal-toc">
            <div className="legal-toc-title">En esta página</div>
            <ul>
              {toc.map(({ id, label }) => (
                <li key={id}>
                  <a href={`#${id}`}>{label}</a>
                </li>
              ))}
            </ul>
          </aside>

          <article className="legal-body">{children}</article>
        </div>
      </div>
      <Footer variant={footerVariant} />
    </>
  );
}
